import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { Group, GroupCore } from '../types/group';
import { deleteRequest, getRequest, postRequest } from './api';
import { groupUrl, groupsUrl } from './urls/groupUrls';

export const getAllGroups = async (
  clientId: string,
  subClientId: string
): Promise<{ allGroups?: Group[]; error?: ApiError }> => {
  const response = await getRequest(groupsUrl, { queryParams: { clientId, subClientId, all_items: true } });
  return {
    allGroups: response?.data?.items,
    error: response?.error,
  };
};

export const getGroups = async (
  clientId: string,
  subClientId: string,
  page: number = 1,
  search: string = ''
): Promise<{ paginatedResponse?: PaginatedResponse<Group>; error?: ApiError }> => {
  const response = await getRequest(groupsUrl, { queryParams: { clientId, subClientId, page, search } });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const deleteGroup = async (
  clientId: string,
  subClientId: string,
  groupId: string
): Promise<{ error?: ApiError }> => {
  const response = await deleteRequest(groupUrl(groupId), { queryParams: { clientId, subClientId } });

  return {
    error: response?.error,
  };
};

export const updateGroup = async (group: GroupCore): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(groupUrl(group._id), {
    body: {
      subAccountId: group.subAccount || undefined,
      subClientId: group.subClient,
      clientId: group.client,
      assets: group.assignedAssets,
      name: group.name,
    },
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const postGroup = async (group: GroupCore): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(groupsUrl, {
    body: {
      subAccountId: group.subAccount || undefined,
      subClientId: group.subClient,
      clientId: group.client,
      assets: group.assignedAssets,
      name: group.name,
    },
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};
